import uniqby from 'lodash.uniqby'

export default function selectProperData(data) {
  const {
    jobID, status, services, results
  } = data;
  if (data.status === 'created') {
    return { jobID, status, services }
  }

  const sentences = results?.sentences.map(sentence => ({
    content: sentence.content,
    search: uniqby(sentence.search, 'location')
  }))
  const urls = results?.urls
    .filter(url => sentences.some(sentence => sentence.search.some(result => result.location === url.location)))

  return {
    jobID,
    status,
    results: { sentences, urls }
  };
}

export function genTickPayload(jobID) {
  return { type: 'tick', jobID };
}

export function genAttachPayload(jobID) {
  return { type: 'attach', jobID };
}
